import React, {FunctionComponent, useEffect, useState} from 'react'
import {Moment} from 'moment'
import {useTranslation} from 'react-i18next'
import formatTime from '../../../../App/Helpers/formatTime'
import getTypes from '../getTypes'

type IProps = {
    result: any,
    from: Moment,
    to: Moment
}

const Body: FunctionComponent<IProps> = ({result, from, to}) => {
    const {t} = useTranslation()
    const [persons, setPersons] = useState()

    const transformAbsenceMinutes = (person: any) => {
        const copy = Object.assign({}, person)
        if (!copy.absence_minutes) {
            return copy
        }

        const days: number = to.diff(from, 'days')
        let totalMinutes: { [key: string]: number } = {}
        for (let i = 0; i <= days; i++) {
            let key = from.clone().add(i, 'days').format('YYYY-MM-DD')
            if (!copy.absence_minutes[key]) {
                continue
            }

            for (let j = 0; j < copy.absence_minutes[key].length; j++) {
                let type = copy.absence_minutes[key][j].type
                if (!copy[type]) {
                    copy[type] = {}
                }

                let minutes = copy.absence_minutes[key][j].minutes
                // If official holiday exists, move all working minutes to public_holiday
                if (
                    minutes === 0
                    && type === 'public_holiday'
                    && copy.working_minutes
                    && copy.working_minutes[key]
                ) {
                    minutes = copy.working_minutes[key]
                    copy.working_minutes[key] = 0
                }

                if (!copy[type][key]) {
                    copy[type][key] = 0
                }
                copy[type][key] += minutes

                if (!totalMinutes[type]) {
                    totalMinutes[type] = 0
                }
                totalMinutes[type] += minutes
            }
        }

        for (let type in totalMinutes) {
            if (totalMinutes[type] === 0) {
                delete copy[type]
            }
        }

        return copy
    }

    useEffect(
        () => {
            setPersons(result.persons.map(transformAbsenceMinutes))
        },
        [result]
    )

    if (typeof persons === 'undefined') {
        return <tbody/>
    }

    const getRowByDay = (person: any) => {
        const rows = []

        let firstRow = true
        for (let name in person) {
            if (name === 'id' || name === 'name' || name == 'absence_minutes') {
                continue
            }

            let totalMinutes = 0
            const cells = []
            for (let i = 0; i < 7; i++) {
                let minutes = person[name][from.clone().add(i, 'days').format('YYYY-MM-DD')]

                minutes = minutes ? minutes : 0
                totalMinutes += minutes
                cells.push(
                    <td key={'personCell' + name + person.id + '_' + i} className={'text-center'}>
                        {formatTime(minutes)}
                    </td>
                )
            }

            rows.push(
                <tr key={'personRow' + name + person.id}>
                    <td>{firstRow ? person.name : null}</td>
                    <td>{t(name)}</td>
                    {cells}
                    <td>{formatTime(totalMinutes)}</td>
                </tr>
            )
            firstRow = false
        }

        return rows
    }

    const getRowsByType = () => {
        let rows = []
        let types = getTypes(result)
        const days: number = to.diff(from, 'days')
        for (const person of persons) {
            let firstRow = true
            let totalTypes: { [key: string]: number } = {}
            for (let i = 0; i <= days; i++) {
                let currentDate = from.clone().add(i, 'days')
                rows.push(
                    <tr>
                        <td>{firstRow ? person.name : null}</td>
                        <td>{currentDate.format('ddd DD/MM')}</td>
                        {
                            types.map(
                                (type) => {
                                    let dateKey = currentDate.format('YYYY-MM-DD')
                                    let minutes = 0
                                    if (person[type] && person[type][dateKey]) {
                                        minutes = person[type][dateKey]
                                    }

                                    if (!totalTypes[type]) {
                                        totalTypes[type] = 0
                                    }

                                    totalTypes[type] += minutes

                                    return <td>{formatTime(minutes)}</td>
                                }
                            )
                        }
                    </tr>
                )
                firstRow = false
            }

            rows.push(
                <tr className={'separator-top separator'}>
                    <td/>
                    <th>{t('Total')}</th>
                    {
                        types.map((type) => <th>{formatTime(totalTypes[type])}</th>)
                    }
                </tr>
            )

            rows.push(
                <tr className={'separator'}>
                    <th/>
                    <th/>
                    {types.map((type) => <th>{type}</th>)}
                </tr>
            )
        }

        return rows
    }

    if (persons.length < 1) {

        const rows = []

        let firstRow = true
        const cells = []
        for (let i = 0; i < 7; i++) {
            cells.push(
                <td className={'text-center'}>-</td>
            )
        }

        rows.push(
            <tbody>
                <tr>
                    <td>{t('No data found')}</td>
                    <td></td>
                    {cells}
                    <td>-</td>
                </tr>
            </tbody>
        )

        return rows
    }

    return <tbody>
    {(7 > to.diff(from, 'days')) ? persons.map(getRowByDay) : getRowsByType()}
    </tbody>
}

export default Body
